import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.onboardingProfiles],
        config: {
            headerName: getLocalizedString("profileCodeAlt"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.onboardingProfiles],
        config: {
            headerName: getLocalizedString("profileName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.onboardingProfiles],
        config: {
            headerName: getLocalizedString("comment"),
            field: "comment",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.onboardingProfiles],
        config: {
            headerName: getLocalizedString("trainingSingular"),
            field: "trainingString",
            filter: "agTextColumnFilter",
        }
    },
]